import { Fragment, useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import Layout from "../layout/Layout";
import { initKeycloak } from "./keycloak";
import AuthScreen from "./AuthScreen";

const RequireAuth = ({ debug, children }) => {
  const location = useLocation();
  const [authorized, setAuthorized] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let isMounted = true; // verhindert Updates nach Unmount
    initKeycloak(
      (auth) => {
        if (!isMounted) return;
        setAuthorized(!!auth || debug);
        setIsChecking(false);
      },
      (err) => {
        console.error("Keycloak init failed:", err);
        if (!isMounted) return;
        setAuthorized(debug || false);
        setIsChecking(false);
      }
    );
    return () => {
      isMounted = false;
    };
  }, [debug]);

  if (isChecking) return <AuthScreen />;

  // Sobald geprüft: Render Layout oder Navigate
  return (
    <Fragment>
      {authorized ? (
        <Layout>{children}</Layout>
      ) : (
        <Navigate to="/login" state={{ from: location }} replace />
      )}
    </Fragment>
  );
};

export default RequireAuth;
